import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import "moment/locale/es";
import { useForm } from "../../../hooks/useForm";
import BuscadorPractica from "./BuscadorPractica";
import {
  getPracticasCoseguros,
  addPractica,
  // postPracticasCoseguros,
  postPracticasCtaCteCoseguros,
  resetPracticas,
  postPracticasCtaCteCosegurosExterno,
  getPracticasCosegurosExterno,
} from "../../../actions/coseguros/coseguros";
import { startAlerta } from "../../../actions/ui/alertas";

import {
  Button,
  Grid,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
} from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import { PractimaItem } from "./PracticaItem";
import { TURNOS_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { OBRAS_SOCIALES } from "../../../utils/constants";

export const FormularioCoseguro = (props) => {
  const dispatch = useDispatch();
  const codigoPracticaRef = useRef(null);

  const [displayAddPractica, setDisplayAddPractica] = useState(false);

  const { permisos: permisosUser } = useSelector((state) => state.auth);
  const { practicas } = useSelector((state) => state.coseguros);

  const {
    usuarioTurnoSeleccionado: {
      idEspecialidad,
      centroMedico: { idCentroMedico },
      efectorRed: { idEfectorRed },
    },
  } = props;  

  const displayBotonAddPractica = validarSoloUnPermiso(
    permisosUser,
    TURNOS_PERMISOS.AGREGAR_PRACTICA
  ) && !props.turnoDemanda;

  // console.log({permiso: validarSoloUnPermiso(permisosUser,TURNOS_PERMISOS.AGREGAR_PRACTICA), turnoDemanda: !props.turnoDemanda});
  // console.log({displayBotonAddPractica, idEspecialidad});

  const initialValues = {
    codigoPractica: null,
  };

  const [formValues, , , setearValor] = useForm(initialValues);

  const { codigoPractica } = formValues;  

  useEffect(() => {
    if (props.idObraSocial === OBRAS_SOCIALES.OSOCNA || props.idObraSocial === OBRAS_SOCIALES.OSPCYD) {
      const data = {
        idEspecialidad,
        idCentroMedico,
        idProfesional: idEfectorRed,
        idObraSocial: props.idObraSocial
      };
      dispatch(getPracticasCosegurosExterno(data, props.usuarioTurnoSeleccionado.idTipoTurnoSol));
    }
    else {
      const data = {
        idEspecialidad,
        idCentroMedico,
        idProfesional: idEfectorRed,
        idAgenda: props.desdeBotonAux ? props.idAgenda : null,
      };

      dispatch(getPracticasCoseguros(data, props.usuarioTurnoSeleccionado.idTipoTurnoSol, props.usuarioTurnoSeleccionado));

    }

    return () => {
      dispatch(resetPracticas());
    };
  }, [dispatch, idEspecialidad, idCentroMedico, idEfectorRed]);

  const onClickAgregarHandler = (e) => {
    if (codigoPractica) {
      const practica = {
        idProfesional: props.usuarioTurnoSeleccionado.efectorRed.idEfectorRed,
        idCentroMedico:
          props.usuarioTurnoSeleccionado.centroMedico.idCentroMedico,
        idEspecialidad: props.usuarioTurnoSeleccionado.idEspecialidad,
        idCodNom: codigoPractica.idCodNom,
        codNom: codigoPractica.codNom,
      };
      dispatch(addPractica(practica));
      codigoPracticaRef.current.resetValues();
      setearValor("codigoPractica", null);
    } else {
      dispatch(startAlerta("Ingrese una practica", "warning", "Atencion"));
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    const practicasSeleccionados = [];

    for (const [index, practica] of practicas.entries()) {
      const checked = e.target.elements[`practica-${index}`]?.checked;
      const cantidad =
        e.target.elements[`cantidad-${index}`]?.value === ""
          ? 0
          : Number(e.target.elements[`cantidad-${index}`]?.value);
      const nroAutorizacion =
        e.target.elements[`nroAutorizacion-${index}`]?.value === ""
          ? 0
          : Number(e.target.elements[`nroAutorizacion-${index}`]?.value);
      if (!checked && cantidad > 0) {
        dispatch(
          startAlerta(
            "No se debe especificar una cantidad sin seleccionar una practica",
            "warning",
            "Atencion"
          )
        );
        return;
      } else if (checked && cantidad <= 0) {
        dispatch(
          startAlerta(
            "La cantidad de la practica seleccionada no puede ser menor o igual a 0",
            "warning",
            "Atencion"
          )
        );
        return;
      } else if (checked && cantidad > 0) {
        practicasSeleccionados.push({
          idCodNom: practica.idCodNom,
          codNom: practica.codNom,
          cantidad,
          pideAutorizacion: practica.pideAutorizacion,
          nroAutorizacion
        });
      }
    }

    if (practicasSeleccionados.length > 0) {
      const datosPost = {
        jsonData: JSON.stringify(practicasSeleccionados),
        idAfiliado: props.usuarioTurnoSeleccionado.idAfiliado,
        idAgenda: props.usuarioTurnoSeleccionado.idAgenda,
        agregada: props.desdeBotonAux,
        idAfiliadoExterno: props.usuarioTurnoSeleccionado.idAfiliadoExterno,
        idObraSocial: props.idObraSocial,
      };
      
      if(props.pantallaTurnos || props.pantallaAltaSobretTurnos){        
        if (props.idObraSocial === OBRAS_SOCIALES.OSOCNA || props.idObraSocial === OBRAS_SOCIALES.OSPCYD) {
          dispatch(
            postPracticasCtaCteCosegurosExterno(
              datosPost,
              null,
              null,
              null,
              null,
              false,
              props.changeSteppetTurnos,
              props.closeModalPracticas
            )
          );
        }
        else {
          dispatch(
            postPracticasCtaCteCoseguros(
              datosPost,
              null,
              null,
              null,
              null,
              false,
              props.changeSteppetTurnos,
              props.closeModalPracticas
            )
          );
        }        
      }
      else if (props.idObraSocial === OBRAS_SOCIALES.OSOCNA || props.idObraSocial === OBRAS_SOCIALES.OSPCYD) {
        dispatch(
          postPracticasCtaCteCosegurosExterno(
            datosPost,
            props.setEsPantallaFormulario,
            props.setOpenConfirmar,
            props.closeModalCoseguro,
            props.setOpenPracticasHandler
          )
        );
      }
      else {
        dispatch(
          postPracticasCtaCteCoseguros(
            datosPost,
            props.setEsPantallaFormulario,
            props.setOpenConfirmar,
            props.closeModalCoseguro,
            props.setOpenPracticasHandler
          )
        );
      }

    } else {
      dispatch(
        startAlerta("Por favor seleccione una practica", "warning", "Atencion")
      );
    }
  };

  const closeModal = () => {
    if(props.pantallaAltaSobretTurnos){      
      props.closeModalPracticas();
    }else{
      props.closeModalCoseguro()
      props.setOpenPracticasHandler(false)
    }
  }

  return (
    <ValidatorForm onSubmit={props.turnoDemanda ? props.getValorizacionDemanda : submitHandler}>
      {displayAddPractica && (
        <React.Fragment>
          <Grid container spacing={2} style={{ width: "60%", margin: "auto" }}>
            <Grid item xs={12}>
              <BuscadorPractica
                ref={codigoPracticaRef}
                cod={codigoPractica}
                label="Código Practica"
                fieldsDisabled={false}
                setCod={(val) => setearValor("codigoPractica", val)}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} style={{ width: "60%", margin: "auto" }}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                margin: "1.5rem 0",
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={() => setDisplayAddPractica(false)}
              >
                Cancelar
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={onClickAgregarHandler}
              >
                Agregar +
              </Button>
            </Grid>
          </Grid>
        </React.Fragment>
      )}
      {practicas.length > 0 ? (
        <Table>
          <TableHead
            style={{ display: "table", width: "98.5%", tableLayout: "fixed" }}
          >
            <TableRow>
              <TableCell style={{ width: "10%" }}></TableCell>
              <TableCell style={{ width: "60%" }}>Nombre Practica</TableCell>
              <TableCell style={{ width: "10%" }}>Cantidad</TableCell>
              {props.idObraSocial === OBRAS_SOCIALES.OSOCNA &&
                <TableCell style={{ width: "10%" }}>Autorizacion</TableCell>
              }
            </TableRow>
          </TableHead>
          <TableBody
            style={{ display: "block", maxHeight: "29rem", overflowY: "auto" }}
          >
            {practicas.map((practica, index) => {
              return (
                <PractimaItem
                  key={index}
                  index={index}
                  practica={practica}
                  turnoDemanda={props.turnoDemanda}
                  idObraSocial={props.idObraSocial}
                  cantidadDefault={practica.defaultCantidad}
                  cargaDefaultPractica={props.cargaDefaultPractica}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <div style={{ fontStyle: "italic" }}>No hay practicas</div>
      )}
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: displayBotonAddPractica ? "space-between" : "right",
            margin: "1.5rem 0",
          }}
        >
          {displayBotonAddPractica && (
            <Button
              style={{ margin: "0 1rem" }}
              color="primary"
              variant="contained"
              onClick={() => setDisplayAddPractica(true)}
            >
              Agregar Practica +
            </Button>
          )}
          <div>            
            <Button
              style={{ margin: "0 1rem", display: props.pantallaTurnos && 'none' }}
              color="secondary"
              variant="contained"
              onClick={closeModal}
            >
              Cancelar
            </Button>            
            <Button
              style={{ margin: "0 1rem", display: props.pantallaTurnos && 'none' }}
              type="submit"
              color="primary"
              ref={props.btnRef}
              variant="contained"
            >
              {props.turnoDemanda ? 'Siguiente' : 'Confirmar Practicas'}
            </Button>
          </div>
        </Grid>
      </Grid>
    </ValidatorForm>
  );
};
